export default "__VITE_ASSET__CG16$a6t__"